module.exports = {
    ON_OTT_SELECTIONS_GET: 'ON_OTT_SELECTIONS_GET',
};
